import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { ATTACH_ACTION_SELECT_ACTION_FILE } from '../../AttachActionSelect'

import { TASK_FORM_ACTIONS_ATTACH_EMAIL_THREADS } from './TaskFormActions.constants'

export function getSelectOptions({ serviceRequestValue, t }) {
  return [
    {
      label: t('Tasks.AttachFileActionOptionKey'),
      value: ATTACH_ACTION_SELECT_ACTION_FILE,
    },
    {
      ...(serviceRequestValue
        ? null
        : {
            disabled: true,
            tooltipContent: t('Task.AttachEmailThreadsDisabledTootipKey'),
            tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.top,
          }),
      label: t('Tasks.AttachEmailThreadsActionOptionKey'),
      value: TASK_FORM_ACTIONS_ATTACH_EMAIL_THREADS,
    },
  ]
}
